import "./index.css";
import { useState, useEffect } from "react";
import LandingPageRoute from "@/routes/mockups.landing-page/route";
import AboutRoute from "@/routes/about/route";
import PrivacyRoute from "@/routes/privacy/route";
import TermsRoute from "@/routes/terms/route";

function getPath() {
	return window.location.pathname;
}

export function App() {
	const [path, setPath] = useState(getPath);

	useEffect(() => {
		const onPop = () => setPath(getPath());
		window.addEventListener("popstate", onPop);
		return () => window.removeEventListener("popstate", onPop);
	}, []);

	switch (path) {
		case "/about":
			return <AboutRoute />;
		case "/privacy":
			return <PrivacyRoute />;
		case "/terms":
			return <TermsRoute />;
		default:
			return <LandingPageRoute />;
	}
}

export default App;
